<template>
    <div class="container">
        <Header :isLight="isLight" :isMenuLight="isMenuLight" class="static-header"></Header>
        <h2 class="page-title">公告通知</h2>
        <div class="article-list">
            <ul>
                <li class="article-item" v-for="(item,index) in list" :key="item.id">
                    <div class="article-item-inner">
                        <h3 class="article-title" @click="handleToDetail(item.id)">{{item.title}}</h3>
                        <div class="article-content">
                            {{item.subtitle}}
                        </div>
                        <p class="time">{{formatTime(item.publishTime)}}</p>
                    </div>
                </li>
            </ul>
            <!-- <div class="bottom clearfix">
                <div class="bottom-page">
                    {{currentPage}}
                </div>
                <div class="toggle-btn-wrapper fr">
                    <a herf="javascript:;" class="toggle-btn toggle-btn-left" :class="{disabled:currentPage <=1}" @click="handlePrev">
                        <Icon type="ios-arrow-back"></Icon>
                    </a>
                    <a herf="javascript:;" class="toggle-btn" :class="{disabled:currentPage >= totalPages}" @click="handleNext">
                        <Icon type="ios-arrow-forward"></Icon>
                    </a>
                </div>
            </div> -->
        </div>
        <div class="pagin">
            <Page :total="totalPages" :page-size="6" size="small" @on-change="handlePageChange"></Page>
        </div>
        <Bottom></Bottom>
        <!-- <div class="page">
            <div class="current">{{currentPage}}</div>
            <div class="bar"></div>
            <div class="total">{{totalPages}}</div>
        </div> -->
    </div>
</template>
<script>
import { articleListMixin } from '@/mixins/articleListMixin'
export default {
    name: 'rules',
    mixins: [articleListMixin],
    data() {
        return {
            articleType: 3
        }
    },
    methods: {
        formatTime(time) {
            return this.$moment(time).format('YYYY/MM/DD')
        }
    }
}
</script>
<style lang="less" scoped>
@import url('../assets/css/rule-list.less');
</style>



// WEBPACK FOOTER //
// src/views/Notice.vue